// C:\Projects\texe\texe-web\src\lib\timeAgo.ts
const rtfCache: Record<string, Intl.RelativeTimeFormat> = {};

function getRtf(locale: string) {
  return (rtfCache[locale] ||= new Intl.RelativeTimeFormat(locale, { numeric: "auto" }));
}

export function formatTimeAgo(
  input: string | number | Date,
  locale = (navigator.language || "tr").toLowerCase()
) {
  const now = Date.now();
  const t = new Date(input).getTime();
  if (!t || Number.isNaN(t)) return "";

  const seconds = Math.round((t - now) / 1000);

  const abs = Math.abs(seconds);
  const rtf = getRtf(locale);

  if (abs < 60) return rtf.format(seconds, "second");
  const minutes = Math.round(seconds / 60);
  if (Math.abs(minutes) < 60) return rtf.format(minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return rtf.format(hours, "hour");
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 30) return rtf.format(days, "day");
  const months = Math.round(days / 30);
  if (Math.abs(months) < 12) return rtf.format(months, "month");
  const years = Math.round(months / 12);
  return rtf.format(years, "year");
}
